import { useEffect, useState } from 'react';
import { EQuoteItemStatusCode } from 'types/quote.types';
import { IQuoteItemDetailsForQuoteManagement } from 'types/quoteEditor.types';
import QuoteEditorToolListItem from '../QuoteEditorToolListItem/QuoteEditorToolListItem';
import './QuoteEditorToolList.scss';

interface IQuoteEditorToolList {
  items: IQuoteItemDetailsForQuoteManagement[];
  toolsStatus: Record<number, EQuoteItemStatusCode>;
  selectedToolId: number;
  onSelectTool: (id: number) => void;
}

/**
 * Sidebar izquierdo del editor de cotización. Muestra el contador de herramientas
 * cotizadas, la barra de progreso y la lista scrolleable de herramientas.
 */
const QuoteEditorToolList = ({ items, toolsStatus, selectedToolId, onSelectTool }: IQuoteEditorToolList) => {
  const quotedCount = items.filter(item => toolsStatus[item.quoteItemId] !== EQuoteItemStatusCode.PENDING_QUOTE).length;
  const total = items.length;
  const progressPercent = total > 0 ? (quotedCount / total) * 100 : 0;
  const [displayPercent, setDisplayPercent] = useState(0);

  useEffect(() => {
    const timeout = setTimeout(() => setDisplayPercent(progressPercent), 80);
    return () => clearTimeout(timeout);
  }, [progressPercent]);

  return (
    <div className="quoteEditorToolList">
      <div className="toolListHeader">
        <span className="toolListTitle">Herramientas cotizadas</span>
        <span className="toolListCount">
          {quotedCount} de {total}
        </span>
      </div>
      <div className="progressBarTrack">
        <div className="progressBarFill" style={{ width: `${displayPercent}%` }} />
      </div>
      <div className="divider" />
      <div className="toolListItems">
        {items.map(item => (
          <QuoteEditorToolListItem
            key={item.quoteItemId}
            item={item}
            status={toolsStatus[item.quoteItemId]}
            isSelected={item.quoteItemId === selectedToolId}
            handleClick={onSelectTool}
          />
        ))}
      </div>
    </div>
  );
};

export default QuoteEditorToolList;
